import React, {useContext} from 'react';
import './OrderStatusBadge.less';

import {Badge, BadgeStyles} from 'elements/badge/Badge';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";


export const OrderStatusBadge = ({orderStatus}) => {
	const translations = useContext(TranslationsContext);

	switch (orderStatus) {
		case 'order_status_cancelled'://TODO
			return <Badge text={getSafeTranslation('OrderStatusBadge.cancelledCaption', translations)}
										style={BadgeStyles.ERROR}
			/>
			break;
		case 'order_status_received':
			return <Badge text={getSafeTranslation('OrderStatusBadge.receivedCaption', translations)}
										style={BadgeStyles.WARNING}
			/>
			break;
		case 'order_status_confirmed'://TODO
			return <Badge text={getSafeTranslation('OrderStatusBadge.confirmedCaption', translations)}
										style={BadgeStyles.WARNING}
			/>
			break;
		case 'order_status_delivered':
			return <Badge text={getSafeTranslation('OrderStatusBadge.deliveredCaption', translations)}
										style={BadgeStyles.SUCCESS}
			/>
			break;
		case 'order_status_in_progress':
			return <Badge text={getSafeTranslation('OrderStatusBadge.inProgressCaption', translations)}
										style={BadgeStyles.WARNING}
			/>
			break;
		default:
			return <Badge
				text={orderStatus}
				style={BadgeStyles.WARNING}
			/>
			break;
	}
	return
}
